import React, { useEffect, useState } from 'react'
import './NotificationSort.scss'
import { NotificationInterface } from '../../../../Models/Notification'
interface NotificationSortPropInterface {
  data: NotificationInterface[],
  setFilterData: any,
  openPanel: boolean
}

const NotificationSort = (props: NotificationSortPropInterface) => {

  const { data, openPanel, setFilterData } = props
  const [sortFilter, setSortFilter] = useState<{sort: string, filter: string[]}>({
    sort: "none",
    filter: []
  })

  const ResetAllSortFilterStates = () => {
    setSortFilter({
      sort: "none",
      filter: []
    })
  }

  const HandleSortAndFilterData = () => {
    // Filter
    let newFilterData = null
    if(sortFilter.filter.length === 0) {
      newFilterData = [...data]
    }
    else {
      newFilterData = [...data].filter((i) => {
        return sortFilter.filter.includes(i.severity)
      })
    }

    // Sort
    if(sortFilter.sort !== "none") {
      newFilterData = [...newFilterData].sort((a, b) => {
        if(a.severity === sortFilter.sort) return -1
        if(b.severity === sortFilter.sort) return 1
        return 0
      })
    }

    setFilterData(newFilterData);
  }

  // ===== HANDLE SORT =====
  const resetHandleSort = () => {
    const newFiterData = {
      sort: "none",
      filter: [...sortFilter.filter]
    }
    setSortFilter(newFiterData)
  }

  const HandleSort = (e: any) => {
    if(sortFilter.sort === e.target.value) resetHandleSort()
    else {
      const newFiterData = {
        sort: e.target.value,
        filter: [...sortFilter.filter]
      }
      setSortFilter(newFiterData)
    }
  }

  // ===== HANDLE FILTER =====
  const HandleFilter = (e: any) => {
    const filterArray = [...sortFilter.filter]
    if(filterArray.includes(e.target.value)) {
      const removeIdx = filterArray.indexOf(e.target.value)
      filterArray.splice(removeIdx, 1)
    } 
    else {
      filterArray.push(e.target.value)
    }
    const newFiterData = {
      sort: sortFilter.sort,
      filter: [...filterArray]
    }
    setSortFilter(newFiterData)
  }

  const SortBox = () => (
    <div className="sortBox">
      <h3 className='sortBoxHead'>Sort by:</h3>
      <ul className='sortBoxList'>
        <li className="sortBoxListItem">
          <input type="radio" name="sort" id="urgent" value="urgent" checked={sortFilter.sort === "urgent"} onClick={HandleSort} onChange={()=>{}} />
          <label htmlFor="urgent">Sort By Urgent</label>
        </li>
        <li className="sortBoxListItem">
          <input type="radio" name="sort" id="info" value="info" checked={sortFilter.sort === "info"} onClick={HandleSort} onChange={()=>{}} />
          <label htmlFor="info">Sort By Info</label>
        </li>
        <li className="sortBoxListItem">
          <input type="radio" name="sort" id="warning" value="warning" checked={sortFilter.sort === "warning"} onClick={HandleSort} onChange={()=>{}} />
          <label htmlFor="warning">Sort By Warning</label>
        </li>
        <li className="sortBoxListItem">
          <input type="radio" name="sort" id="success" value="success" checked={sortFilter.sort === "success"} onClick={HandleSort} onChange={()=>{}} />
          <label htmlFor="success">Sort By Success</label>
        </li>
      </ul>
    </div>
  )

  const FilterBox = () => (
    <div className="filterBox">
      <h3 className='sortBoxHead'>View mode:</h3>
      <ul className='sortBoxList'>
        <li className="sortBoxListItem">
          <input type="checkbox" name="filter" id="urgentFilter" value="urgent" checked={sortFilter.filter.includes("urgent")} onClick={HandleFilter} onChange={()=>{}} />
          <label htmlFor="urgentFilter">Urgent</label>
        </li>
        <li className="sortBoxListItem">
          <input type="checkbox" name="filter" id="infoFilter" value="info" checked={sortFilter.filter.includes("info")} onClick={HandleFilter} onChange={()=>{}} />
          <label htmlFor="infoFilter">Info</label>
        </li>
        <li className="sortBoxListItem">
          <input type="checkbox" name="filter" id="warningFilter" value="warning" checked={sortFilter.filter.includes("warning")} onClick={HandleFilter} onChange={()=>{}} />
          <label htmlFor="warningFilter">Warning</label>
        </li>
        <li className="sortBoxListItem">
          <input type="checkbox" name="filter" id="successFilter" value="success" checked={sortFilter.filter.includes("success")} onClick={HandleFilter} onChange={()=>{}} />
          <label htmlFor="successFilter">Success</label>
        </li>
      </ul>
    </div>
  )

  useEffect(() => {
    HandleSortAndFilterData()
    // eslint-disable-next-line
  }, [sortFilter])

  useEffect(() => {
    ResetAllSortFilterStates()
    // eslint-disable-next-line
  }, [openPanel])

  return (
    <div className="notificationSortBox">
      { SortBox() }
      { FilterBox() }
    </div>
  )
}

export default NotificationSort